// ⚠️ AUTOMATICALLY GENERATED - DO NOT CHANGE
export const CHANNEL = '58800b0f-b2cb-4c43-8c1b-48a9a6d9d246';

export const MAIN = 'M' + CHANNEL;
export const THREAD = 'T' + CHANNEL;
